/**
 * script 로드 함수
 */
export const loadScript = (src: string): Promise<void> =>
  new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);

    if (existing) {
      // 이미 로드 완료된 경우
      if ((existing as any).__loaded) return resolve();
      if ((existing as any).__error)
        return reject(new Error(`script 로드 실패: ${src}`));
      // 로드 중인 경우 — 완료 대기
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () =>
        reject(new Error(`script 로드 실패: ${src}`)),
      );
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      (script as any).__loaded = true;
      resolve();
    };

    script.onerror = () => {
      (script as any).__error = true;
      reject(new Error(`로드 실패: ${src}`));
    };
    document.body.appendChild(script);
  });

/**
 * wasm 파일 로드 기다리는 함수
 */
export const waitForWasm = (): Promise<void> =>
  new Promise(resolve => {
    // @ts-expect-error: KeypadCryptoWASM global Module is not typed
    if (window.Module?.calledRun) return resolve(); // 이미 완료 → 즉시 통과

    // 아직 초기화 전 → 완료 콜백 등록
    // @ts-expect-error: KeypadCryptoWASM global Module is not typed
    window.Module = window.Module ?? {};
    // @ts-expect-error: KeypadCryptoWASM global Module is not typed
    const prev = window.Module.onRuntimeInitialized;
    // @ts-expect-error: KeypadCryptoWASM global Module is not typed
    window.Module.onRuntimeInitialized = () => {
      prev?.();
      resolve();
    };
  });

const base = process.env.PUBLIC_URL;

/**
 * Keypad 관련 script들 로드 함수
 * 순서: KeypadCryptoWASM 파일 로드 후 keypadsuit 파일 로드
 */
export const loadKeypadScripts = (): Promise<void> =>
  loadScript(`${base}js/KeypadCryptoWASM.js`)
    .then(() => waitForWasm())
    .then(() => loadScript(`${base}js/keypadsuit_24.0.0.min.js`));
